<template>
  <span
    role="button"
    :class="$style.removeButton"
    data-qa="remove-button"
    @click.stop="handleClick"
  >
    <base-icon
      :class="[$style.removeIcon, { [$style.error]: hasError }]"
      type="x-close"
    />
  </span>
</template>

<script setup lang="ts">
import BaseIcon from '@/shared/legacy/ui/base-icon/icon.vue';
import { useI18N } from '@/shared/legacy/lib/use-i18n';

type Props = {
  confirmOnRemove?: boolean;
  hasError?: boolean;
};

const { confirmOnRemove = false, hasError = false } = defineProps<Props>();

const emit = defineEmits<{
  action: [event: MouseEvent];
}>();

const i18n = useI18N();

const handleClick = (event: MouseEvent) => {
  if (confirmOnRemove && !confirm(i18n('confirm'))) {
    return;
  }
  emit('action', event);
};
</script>

<i18n lang="json">
{
  "confirm": {
    "ru_RU": "Несохраненные данные будут утеряны. Все равно удалить?",
    "en_US": "All unsaved data will be lost. Still want to remove?"
  }
}
</i18n>

<style module>
.removeButton {
  @mixin reset-button-styles;
  flex: none;
  display: inline-flex;
  cursor: pointer;
}

.removeIcon {
  color: $gray-500;
}

.error {
  color: $red-500;
}
</style>
